import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useContext } from "react";
import { DialogProvider, createDialogContext } from "../../../Common/Dialog";

export const UpcomingScheduledUpdateDialogContext = createDialogContext();

const UpcomingScheduledUpdateDialog = ({
  isLoading = false,
  onEditScheduledUpdate,
}: {
  isLoading: boolean;
  onEditScheduledUpdate: () => void;
}) => {
  const { isOpen, close, text, title, actions } = useContext(
    UpcomingScheduledUpdateDialogContext
  );

  const _onClose = () => {
    close();
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={_onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          mb={[0, "auto"]}
          borderBottomLeftRadius={[0, "md"]}
          borderBottomRightRadius={[0, "md"]}
        >
          <ModalHeader paddingTop={4}>
            <VStack gap={0} width={"full"}>
              <Text w="full">Upcoming scheduled update</Text>
            </VStack>
          </ModalHeader>
          <ModalBody textAlign={"left"}>
            <VStack w="full">
              <Text w="full">Your changes have been saved!</Text>
              <Text color="red.500" w="full">
                Heads up: a scheduled update will override these changes . Want
                to edit that too?
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Stack direction={["column-reverse", "row-reverse"]} width="100%">
              <Button
                onClick={onEditScheduledUpdate}
                isLoading={isLoading}
                backgroundColor={"green.500"}
                color="white"
                isDisabled={isLoading}
              >
                Edit Scheduled Update
              </Button>
              <Button
                onClick={_onClose}
                isLoading={isLoading}
                isDisabled={isLoading}
              >
                No Thanks
              </Button>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export const withUpcomingScheduledUpdateDialog =
  <T extends object>(Component: React.ComponentType<T>) =>
  (props: T) => {
    return (
      <DialogProvider context={UpcomingScheduledUpdateDialogContext}>
        <Component {...(props as T)} />
      </DialogProvider>
    );
  };

export default UpcomingScheduledUpdateDialog;
